import Grid from '@mui/material/Unstable_Grid2'
import { CustomTextField } from '../../../../../../shared/components/inputs'
import { IUser, ROLES } from '../../../../models/user'
import { ClientTypeAutocomplete } from '../../forms/ClientTypeAutocomplete'
import { RoleSelect } from '../../forms/RoleSelect'
import { UserLanguageAutocomplete } from '../../forms/UserLanguageAutocomplete'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../../redux/types'

interface GeneralClientTabProps {
  user: IUser
  handleInputChange: (inputName: string, value: any) => void
}

export function GeneralClientTab({ user, handleInputChange }: GeneralClientTabProps) {
  const { user: authUser } = useSelector((state: IRootState) => state.auth)

  return (
    <Grid container spacing={2}>
      {authUser.role_id !== ROLES.client && (
        <Grid xs={12} sm={6} md={4}>
          <RoleSelect roleId={user.role_id} handleInputChange={handleInputChange} />
        </Grid>
      )}

      {authUser.role_id !== ROLES.client && (
        <Grid xs={12} sm={6} md={4}>
          <UserLanguageAutocomplete userLanguages={user.languages} handleInputChange={handleInputChange} />
        </Grid>
      )}

      {authUser.role_id !== ROLES.client && (
        <Grid xs={12} sm={6} md={4}>
          <ClientTypeAutocomplete clientTypeId={user.client_type} handleInputChange={handleInputChange} />
        </Grid>
      )}

      <Grid xs={12} sm={6}>
        <CustomTextField inputName={'email'} value={user.email} handleInputChange={handleInputChange} required />
      </Grid>

      <Grid xs={12} sm={6}>
        <CustomTextField inputName={'phone'} value={user.phone} handleInputChange={handleInputChange} />
      </Grid>
    </Grid>
  )
}
